import { useState } from "react";
import { uploadsUrl } from "../utils/api";
import "./TowerSection.css";

// 🔹 Read More
function ReadMore({ text, limit = 180 }) {
  const [expanded, setExpanded] = useState(false);

  const sanitize = (str) =>
    str.replace(/</g, "&lt;").replace(/>/g, "&gt;");

  if (!text) return null;

  const safeText = sanitize(text).replace(/\n/g, "<br/>");

  if (text.length <= limit) {
    return <p dangerouslySetInnerHTML={{ __html: safeText }} />;
  }

  return (
    <p>
      <span
        dangerouslySetInnerHTML={{
          __html: expanded
            ? safeText
            : sanitize(text.slice(0, limit) + "…").replace(/\n/g, "<br/>"),
        }}
      />
      <button
        className="read-more-btn"
        onClick={() => setExpanded((e) => !e)}
      >
        {expanded ? " Read Less" : " Read More..."}
      </button>
    </p>
  );
}

// 🔹 Main Component
export default function TowerSection({ projectId, tower = {}, onCtaClick }) {
  const { list = [] } = tower;

  if (!list.length) return null;

  return (
    <section className="tower-section section">
      <div className="container">

        <h2 className="section-heading">
          Project Highlights
        </h2>

        {list.map((tw, i) => (
          <article
            key={i}
            className={`tower-row ${
              i % 2 !== 0 ? "tower-row--reversed" : ""
            }`}
          >
            
            {/* 🔹 CARD */}
            <div className="tower-card">
              <div className="tower-card__inner">

                {/* FRONT */}
                <div className="tower-card__front">
                  <img
                    src={uploadsUrl(projectId, `tower${i + 1}.webp`)}
                    alt={`${tw.title} image`}
                    loading="lazy"
                    onError={(e) => (e.target.src = "/fallback.webp")}
                  />
                </div>

                {/* BACK */}
                <div className="tower-card__back">
                  <img
                    src={uploadsUrl(projectId, `tower${i + 1}.webp`)}
                    alt={`${tw.title} brochure`}
                    className="tower-card__back-blur"
                    loading="lazy"
                    onError={(e) => (e.target.src = "/fallback.webp")}
                  />

                  <div className="tower-card__back-content">
                    <h3>{tw.title}</h3>

                    {/* ✅ FIXED CTA */}
                    <button
                      className="btn-primary"
                      onClick={() =>
                        onCtaClick?.(
                          `Tower Brochure - ${tw.title}`,
                          true,
                          {
                            tower: tw.title,
                            type: "brochure",
                          }
                        )
                      }
                    >
                      Download Brochure
                    </button>
                  </div>
                </div>

              </div>
            </div>

            {/* 🔹 DETAILS */}
            <div className="tower-details">
              <h3>{tw.title}</h3>

              <ReadMore text={tw.description} limit={180} />

              {/* ✅ FIXED CTA */}
              <button
                className="btn-primary tower-details__btn"
                onClick={() =>
                  onCtaClick?.(
                    `Tower CTA - ${tw.title}`,
                    true,
                    {
                      tower: tw.title,
                      type: "payment_plan",
                    }
                  )
                }
              >
                {tw.paymentPlan || "Download Payment Plan"}
              </button>
            </div>

          </article>
        ))}
      </div>
    </section>
  );
}